/**
 * Тексти інтерфейсу. Основна мова сервісу англійська (`en`). Щоб додати мову,
 * скопіюйте словник `en` і переведіть значення; вона вмикається параметром ?lang=xx.
 */
const en = {
  title: 'Random video chat',
  subtitle: 'Meet new people instantly. No sign-up.',
  ageConfirm: 'I am 18 or older and agree to the rules',
  start: 'Start',
  next: 'Next',
  stop: 'Stop',
  report: 'Report',
  block: 'Block',
  blocked: 'Blocked. You will never be matched with them again.',
  mute: 'Mute microphone',
  unmute: 'Unmute microphone',
  camOff: 'Turn camera off',
  camOn: 'Turn camera on',
  online: 'online',
  rules: 'Rules',
  privacy: 'Privacy',
  status_starting: 'Waiting for camera access…',
  status_connecting: 'Connecting to the server…',
  status_searching: 'Looking for someone to talk to…',
  status_pairing: 'Found someone, connecting…',
  status_ready: 'Press Start to find someone',
  peer_left: 'Your partner left. Looking for someone new…',
  peer_timeout: 'Could not connect. Looking for someone new…',
  reported: 'Thanks, your report was sent.',
  rateLimited: 'Too many searches, please wait a moment.',
  reportTitle: 'Report this user',
  reportSend: 'Send report',
  cancel: 'Cancel',
  reason_nudity: 'Nudity or sexual content',
  reason_harassment: 'Harassment or abuse',
  reason_minor: 'Appears to be under 18',
  reason_spam: 'Spam or advertising',
  reason_other: 'Other',
  retry: 'Try again',
  err_denied: 'Camera or microphone access was blocked. Allow access in the browser settings and try again.',
  err_notfound: 'No camera or microphone was found on this device.',
  err_camera: 'The camera could not be started. Close other apps that may be using it and try again.',
  err_banned: 'Access to this service has been restricted.',
  err_restricted: 'This session has been temporarily restricted pending review.',
  err_replaced: 'The chat was opened in another tab. Close it to use this one.',
  err_version: 'The app is out of date. Please reload the page.',
  err_server: 'Something went wrong. Please try again.',
  you: 'You',
};

const uk: typeof en = {
  title: 'Відеочат з випадковими співрозмовниками',
  subtitle: 'Знайомтесь з новими людьми одразу. Без реєстрації.',
  ageConfirm: 'Мені виповнилося 18 років, я погоджуюсь із правилами',
  start: 'Почати',
  next: 'Наступний',
  stop: 'Стоп',
  report: 'Поскаржитись',
  block: 'Заблокувати',
  blocked: 'Заблоковано. Ви більше ніколи не зустрінетесь.',
  mute: 'Вимкнути мікрофон',
  unmute: 'Увімкнути мікрофон',
  camOff: 'Вимкнути камеру',
  camOn: 'Увімкнути камеру',
  online: 'онлайн',
  rules: 'Правила',
  privacy: 'Конфіденційність',
  status_starting: 'Очікуємо доступ до камери…',
  status_connecting: 'Підключаємось до сервера…',
  status_searching: 'Шукаємо співрозмовника…',
  status_pairing: 'Знайшли, з’єднуємо…',
  status_ready: 'Натисніть «Почати», щоб знайти співрозмовника',
  peer_left: 'Співрозмовник пішов. Шукаємо нового…',
  peer_timeout: 'Не вдалося з’єднатися. Шукаємо нового…',
  reported: 'Дякуємо, скаргу надіслано.',
  rateLimited: 'Забагато пошуків, зачекайте трохи.',
  reportTitle: 'Скарга на користувача',
  reportSend: 'Надіслати скаргу',
  cancel: 'Скасувати',
  reason_nudity: 'Оголення або сексуальний вміст',
  reason_harassment: 'Образи або переслідування',
  reason_minor: 'Схоже, що йому менше 18',
  reason_spam: 'Спам або реклама',
  reason_other: 'Інше',
  retry: 'Спробувати ще раз',
  err_denied: 'Доступ до камери або мікрофона заблоковано. Дозвольте його в налаштуваннях браузера й спробуйте знову.',
  err_notfound: 'На цьому пристрої не знайдено камери або мікрофона.',
  err_camera: 'Не вдалося запустити камеру. Закрийте інші програми, що її використовують, і спробуйте знову.',
  err_banned: 'Доступ до сервісу обмежено.',
  err_restricted: 'Цю сесію тимчасово обмежено до розгляду модератором.',
  err_replaced: 'Чат відкрито в іншій вкладці. Закрийте її, щоб користуватися цією.',
  err_version: 'Застосунок застарів. Оновіть сторінку.',
  err_server: 'Щось пішло не так. Спробуйте ще раз.',
  you: 'Ви',
};

export const dictionaries = { en, uk } as const;
export type Lang = keyof typeof dictionaries;
export type Dict = typeof en;
export type Key = keyof Dict;

export const DEFAULT_LANG: Lang = 'en';

/**
 * Сервіс англомовний: мова за замовчуванням завжди English, незалежно від мови
 * браузера. Інша мова вмикається лише явно параметром ?lang=xx (наприклад, для
 * майбутніх локалізованих сторінок WordPress).
 */
export function detectLang(): Lang {
  const fromUrl = new URLSearchParams(location.search).get('lang')?.toLowerCase().split('-')[0];
  return fromUrl && fromUrl in dictionaries ? (fromUrl as Lang) : DEFAULT_LANG;
}
